export const apiUrl = process.env.API_URL;
export const version = process.env.VERSION;
export const root_url = process.env.VUE_APP_ROOT_API;
export const userTokenStorageKey = "APP_USER_TOKEN";
export const authDisabled = false;
export const bridgeAngularJS = false;
export const permanent = true;

/* Permission Based Config */
export const DefaultPermissions = { home: { deny: false } };
export const PermAdminRole = "Administrator";
